import type { MentionSeriesFolderBook } from "./resolveSeriesBooksFromFolderProjects";

/**
 * Decide whether global series-store contents belong to the Firebase project open in tab Story Chat.
 * Avoids showing another user's series after navigating projects without visiting Story Bible first.
 */
export function resolveSeriesBooksForMentions(
  project: { id?: string; seriesId?: string | null } | null | undefined,
  storeContents: unknown[],
  storeCurrentSeriesId: string | undefined | null,
): MentionSeriesFolderBook[] {
  const firebaseId = typeof project?.id === "string" ? project.id.trim() : "";
  const prismaSeriesId = typeof project?.seriesId === "string" ? project.seriesId.trim() : "";

  if (!firebaseId || !Array.isArray(storeContents) || storeContents.length === 0) {
    return [];
  }

  const books = storeContents.flatMap((book): MentionSeriesFolderBook[] => {
    if (!book || typeof book !== "object") return [];
    const row = book as { projectId?: unknown; title?: unknown; seriesOrder?: unknown };
    const projectId = typeof row.projectId === "string" ? row.projectId.trim() : "";
    if (!projectId) return [];
    const title = typeof row.title === "string" && row.title.trim() ? row.title.trim() : "Untitled Book";
    const parsedSeriesOrder = typeof row.seriesOrder === "number" ? row.seriesOrder : Number(row.seriesOrder);
    const seriesOrder = Number.isFinite(parsedSeriesOrder) ? parsedSeriesOrder : null;
    return [{ projectId, title, seriesOrder }];
  });

  const listIncludesProject = books.some((b) => b.projectId === firebaseId);

  if (!listIncludesProject) {
    return [];
  }

  if (prismaSeriesId && storeCurrentSeriesId !== prismaSeriesId) {
    return [];
  }

  return books;
}